/* eslint-disable @typescript-eslint/ban-types */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Card, Select, Switch, Tabs, TabsProps, Tag, Modal } from 'antd';
import {
	PlusCircleOutlined,
	EditOutlined,
	DeleteOutlined,
	CloseOutlined,
	ArrowLeftOutlined,
} from '@ant-design/icons';
import { Tab } from '@hydrodigital/design-system';

import SourcesDetail from './sources';
import './index.scss';
import Forecast from './forecast';
import InfrastructureService from '../../../../domain/Infrastructure/InfraestructureService';
import InfraestructureContext from '@/contexts/InfraestructureContext';
import { Infrastructure } from '@/domain/Infrastructure/Infrastructure';
import SelectInfrastructure from '@/basicsComponents/Selects/SelectInfrastructure';
import SelectParameter from '@/basicsComponents/Selects/SelectParameter';

const infrastructureService = new InfrastructureService();

type Props = {
	open: boolean;
	infrastructure: Infrastructure | null;
	onClose: Function;
	handleLoadSources: Function;
};

export default function ModalParameterDetail({
	open,
	infrastructure,
	onClose,
	handleLoadSources,
}: Props) {
	const selectParameterRef = useRef<any>(null);
	const selectInfrastructureRef = useRef<any>(null);
	const { value: context, setValue: setContext } = useContext(InfraestructureContext);
	const [selectNav, setSelectNav] = useState('source');
	const [selectedInfrastructure, setSelectedInfrastructure] = useState<any>(null);
	const [selectedParameter, setSelectedParameter] = useState<any>(null);
	const [infraestructures, setInfraestructures] = useState<any[]>([]);
	const [parameters, setParameters] = useState<any[]>([]);

	async function handleSearchInfrastructures(search: any) {
		if (!infrastructure?.locationId) return;
		const response = await infrastructureService.getInfraestructureInUse(
			`${infrastructure.locationId}`,
			1,
			50,
			search,
			null,
			0,
			null,
		);
		setInfraestructures(response.data);
	}

	async function handleSetParameters(val: null) {
		const selectedParameter = infraestructures.find((p) => p.infraestructureId === val);
		if (selectedParameter) {
			setParameters(selectedParameter.measurementParameters);
		}
	}

	useEffect(() => {
		if (context.showAddVariableVirtualParam) {
			handleSearchInfrastructures('');
		}
	}, [context.showAddVariableVirtualParam]);

	useEffect(() => {
		handleSetParameters(selectedInfrastructure);
	}, [selectedInfrastructure]);

	const tabs = [
		{
			id: 'source',
			label: 'REAL-TIME DATA SOURCES',
			content: (
				<SourcesDetail
					sources={context.selectedParam?.sources || []}
					parameter={context.selectedParam}
					infrastructure={infrastructure}
					handleLoadSources={handleLoadSources}
				/>
			),
		},
		{
			key: 'forecast',
			label: 'FORECAST DATA SOURCE',
			content: (
				<div>
					<Forecast infrastructure={infrastructure} onClose={onClose} />
				</div>
			),
		},
	];

	return (
		<Modal className="modal-source-detail" open={open} onCancel={() => onClose()} footer={[]}>
			<div className={context.showAddVariableVirtualParam ? 'flex column' : 'hide'}>
				<ArrowLeftOutlined
					onClick={() => {
						setContext({
							...context,
							selectedVirtualSource: null,
							showAddVariableVirtualParam: false,
							handleAddVariableVirtualParam: null,
						});
						setSelectedInfrastructure(null);
						setSelectedParameter(null);
					}}
				/>
				<div className="flex column mt-3">
					<span className="mb-2">Select parameter</span>
					<div className="flex mb-3">
						<div style={{ minWidth: '200px' }} className="mr-1">
							<SelectInfrastructure
								mode="ByLocation"
								defaultActiveFirstOption={false}
								ref={selectInfrastructureRef}
								location={infrastructure?.locationId}
								onSelect={(val) => {
									setSelectedInfrastructure(val);
									setSelectedParameter(null);
									selectParameterRef.current.setValue(null);
								}}
							/>
						</div>
						<div style={{ minWidth: '200px' }} className="mr-1">
							<SelectParameter
								defaultActiveFirstOption={false}
								ref={selectParameterRef}
								infrastructureId={selectedInfrastructure}
								emitObject={true}
								onSelect={(val) => {
									setSelectedParameter(val);
								}}
							/>
						</div>
						<Button
							type="primary"
							shape="round"
							icon={<PlusCircleOutlined />}
							className="flex items-center ml-auto"
							style={{
								backgroundColor: '#023E65',
								borderColor: '#023E65',
								color: 'white',
								width: '100px',
								height: '32px',
							}}
							onClick={() => {
								if (context.handleAddVariableVirtualParam && selectedParameter) {
									const infra = infraestructures.find(
										(p) => String(p.infraestructureId) === String(selectedInfrastructure),
									);
									context.handleAddVariableVirtualParam({
										...selectedParameter,
										infrastructureName: infra?.infraestructureName ?? '',
									});
									setSelectedInfrastructure(null);
									setSelectedParameter(null);
								}
							}}
						>
							Variable
						</Button>
					</div>
					<div className="flex" style={{ flexWrap: 'wrap' }}>
						{context.selectedVirtualSource?.variables.map((va) => {
							return (
								<Tag
									color="#E8F9FF"
									key={va.parameterId}
									style={{
										color: '#023E65',
										fontWeight: 'bold',
										borderRadius: '20px',
									}}
									className="mr-1 mb-1"
								>
									{va.assetName
									? `${va.assetName}, ${va.parameterName} = ${va.name}`
									: `${va.parameterName} = ${va.name}`}
								</Tag>
							);
						})}
					</div>
				</div>
			</div>

			{/* =========SEPARADOR======= */}

			<div className={!context.showAddVariableVirtualParam ? 'flex column' : 'hide'}>
				<div className="flex justify-between">
					<span
						style={{
							color: '#232B36',
							fontSize: '2rem',
							fontWeight: '600',
						}}
					>
						{context.selectedParam?.name}
					</span>
					{/* <CloseOutlined
            onClick={() => {
              onClose();
            }}
          /> */}
				</div>

				<Tab
					tabs={tabs.map(t => ({ ...t, id: t.id ?? t.key! }))}
					showContent
					orientation="horizontal"
					onTabChange={(id) => console.log('Active tab:', id)}
				/>
			</div>
		</Modal>
	);
}